export default "__VITE_ASSET__BTqVPMJ7__"